import React, { useState } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'

import { Section, Rows } from '@/components/layout'
import { Text, Collapse } from '@/components/common'
import TryFreeCta from '@/components/TryFreeCta'

import styles from './FaqSection.module.scss'

const FaqRow = ({ id, getMessageId }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const { formatMessage } = useIntl()

  const renderMessage = (text) => {
    const parts = []
    const regex = /(\[a href='([^']+)'\](.*?)\[\/a\])|\[br\]/g
    let lastIndex = 0
    let match = regex.exec(text)

    while (match !== null && typeof match.index === 'number') {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index))
      }

      if (match[0] === '[br]') {
        parts.push(<br key={match.index} />)
      } else {
        const url = match[2]
        const label = match[3]
        parts.push(
          <a key={match.index} href={url}>
            {label}
          </a>,
        )
      }
      lastIndex = regex.lastIndex
      match = regex.exec(text)
    }

    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex))
    }
    return parts
  }

  const answer = formatMessage({ id: getMessageId(`${id}.p`) })

  return (
    <div
      className={cx(styles.row, isExpanded && styles.isExpanded)}
      onClick={() => setIsExpanded(wasExpanded => !wasExpanded)}
      role="button"
      tabIndex={0}
    >
      <div className={styles.rowHeader}>
        <Text bold element="div" messageId={getMessageId(`${id}.title`)} />
        <div className={styles.arrow} />
      </div>
      <Collapse isOpen={isExpanded}>
        <div>
          <Text.P size="small">{renderMessage(answer)}</Text.P>
          {id === 'notReady' && <TryFreeCta messageId="cta.freeTrial" />}
        </div>
      </Collapse>
    </div>
  )
}

FaqRow.propTypes = {
  id: PropTypes.string.isRequired,
  getMessageId: PropTypes.func.isRequired,
}

export default function PricingFaq({ pageId = 'pricing', faqs }) {
  const getMessageId = id => `pages.${pageId}.faq.${id}`

  return (
    <Section bgSecondary>
      <Text.H2 center messageId={getMessageId('title')} normal />
      <div className="max-w-600">
        <Rows className="faq-rows">
          {faqs.map(faq => (
            <FaqRow key={faq} getMessageId={getMessageId} id={faq} />
          ))}
        </Rows>
      </div>
    </Section>
  )
}

PricingFaq.propTypes = {
  pageId: PropTypes.string,
  faqs: PropTypes.arrayOf(PropTypes.string),
}
